import {
	AddressTypeV4Enum,
	FavoritePlace,
	FavoritePlaceParams,
	GetBeneficiaryAddressV4AddressItem,
	PredefinedFavoritePlacesEnum,
	PrincipalFavoritePlaceEnum,
} from 'domain/usecases';
import {makeGetBeneficiaryAddressV4} from 'main/factories/usecases';
import {FavoriteAddressesItem} from '../types';

function addressV4ItemToFavoritePlace(item: GetBeneficiaryAddressV4AddressItem): FavoritePlace {
	const isResidential = item.type === AddressTypeV4Enum.RESIDENTIAL;
	const isCommercial = item.type === AddressTypeV4Enum.COMMERCIAL;
	const isBilling = item.type === AddressTypeV4Enum.BILLING;

	let nmLocal: string;
	if (isResidential) {
		nmLocal = PredefinedFavoritePlacesEnum.HOUSE;
	} else if (isCommercial) {
		nmLocal = PredefinedFavoritePlacesEnum.WORK;
	} else if (isBilling) {
		nmLocal = PredefinedFavoritePlacesEnum.BILLING;
	} else {
		nmLocal = item.descriptionType ?? PredefinedFavoritePlacesEnum.OTHER;
	}

	return {
		cdBeneficiarioEnderecoFavorito: item.sequence,
		type: item.type,
		sequence: item.sequence,
		nmLocal: item.descriptionOthers ? item.descriptionOthers : nmLocal,
		nmLogradouro: [item.streetType, item.street].filter(Boolean).join(' '),
		nuEndereco: Number(item.streetNumber) || 0,
		nmBairro: item.district,
		nmCidade: item.city,
		nmUf: item.state,
		nuCep: item.zipCode,
		flPrincipal: isResidential ? PrincipalFavoritePlaceEnum.YES : PrincipalFavoritePlaceEnum.NO,
		cdLatitude: item.latitude != null ? String(item.latitude) : '',
		cdLongitude: item.longitude != null ? String(item.longitude) : '',
		dsComplemento: item.complement ?? '',
	};
}

export async function getFavoriteAddresses({
	signal,
	isHolder,
}: FavoritePlaceParams): Promise<FavoriteAddressesItem[]> {
	const response = await makeGetBeneficiaryAddressV4().get({signal});

	if (!Array.isArray(response?.addresses)) {
		return [];
	}

	return response.addresses
		.filter(item => isHolder || item.type !== AddressTypeV4Enum.BILLING)
		.map(item => {
			const address = addressV4ItemToFavoritePlace(item);

			return {
				id: `${address.nmLocal}-${address.cdBeneficiarioEnderecoFavorito}-${address.nuCep}`,
				address,
			};
		});
}
